import React from 'react'
import styled from 'styled-components'

const SwapPanel = styled.div`
  color: ${({ theme }) => theme.tradePanelTextColor};
  background-color: ${({ theme }) => theme.tradePanelBackgroundColor};
  border: 0px solid ${({ theme }) => theme.tradePanelBorderColor};

  box-shadow: ${({ theme }) => theme.tradePanelShadow};

  border-radius: 4.5rem;
  font-size: 2rem;
  justify-content: space-between;
  overflow: hidden;
  padding: 1.5rem 0.5rem;
  outline: none;
  text-decoration: none;
  text-align: left;

  display: flex;
  flex-direction: column;
  align-self: center;

  /* Mobiles */
  @media (max-width: 640px) {
    padding-top: 0.75rem;
    border-radius: 4rem;
  }
`

export default SwapPanel
